module.exports = __webpack_public_path__ + "img/ic_ticket_expired.c7584bf8.svg";